module.exports = __webpack_public_path__ + "static/media/air-india-logo.d7adcf6b.png";